import { MAX_CODE_HEIGHT, ROW_HEIGHT, ROW_WIDTH } from './constants';
import { SyntaxHighlighterRow } from './types';

export function isValidUrl(string: string) {
  try {
    const url = new URL(string);
    const path = url.pathname.toLowerCase();
    return /\/[^/]+\.(jpg|jpeg|png|gif|svg|webp)$/i.test(path);
  } catch (_) {
    return false;
  }
}

export function isBase64Image(string: string) {
  return /^data:image\/[a-z]+;base64,/.test(string);
}

export function calculateTotalHeight(
  rows: SyntaxHighlighterRow[],
  containerWidth?: number
) {
  const totalRows = rows.reduce((sum, row) => {
    const text = row.children
      .map((child) => child.children?.[0]?.value || '')
      .join('');

    const charsPerLine = containerWidth
      ? Math.floor(containerWidth / 8)
      : ROW_WIDTH;
    const additionalRows = Math.floor(text.length / charsPerLine);
    return sum + 1 + additionalRows;
  }, 0);

  const height = totalRows * ROW_HEIGHT;

  return Math.min(height, MAX_CODE_HEIGHT);
}
